<!-- TEMPLATE -->
<template>
  <transition name="slide-up" appear>
    <div :class="popUpNotificationClass" class="row">
      <div v-if="data.icon" class="all-1-half columns info-icon">
        <dean-icon :glyph="data.icon" width="20"></dean-icon>
      </div>
      <div v-else class="all-1-half columns info-icon">
        <dean-icon :glyph="emptyIcon" width="20"></dean-icon>
      </div>
      <div class="all-9 columns dean-popup-notification-text">
        <p>{{ data.text }}</p>
        <slot></slot>
      </div>
      <div v-if="hideCloseButton == false" class="all-1-half columns close-icon" @click="closeClick">
        <dean-icon :glyph="closeIcon" width="15"></dean-icon>
      </div>
    </div>
  </transition>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

// SVG
import closeIcon from '../svg/feather-icons/x.svg';
import emptyIcon from '../svg/icons/empty.svg';
// COMPONENTS
import deanIcon from './deanIcon.vue';

// COMPONENTS
@Component({
  components: {
    deanIcon
  }
})

// EXPORT
export default class deanPopUpNotification extends Vue {
  // PROPS
  @Prop()
  @Prop()
  data!: object;
  @Prop() theme!: string;
  @Prop({ default: false }) standard!: boolean;
  @Prop({ default: false }) hideCloseButton!: boolean;
  @Prop({ default: false }) success!: boolean;
  @Prop({ default: false }) info!: boolean;
  @Prop({ default: false }) warning!: boolean;
  @Prop({ default: false }) danger!: boolean;

  // DATA
  closeIcon: object = closeIcon;
  emptyIcon: object = emptyIcon;
  show: boolean = true;

  // EMITS
  @Emit('close') closeClick() {
    console.log('close popUpNotification');
  }

  // COMPUTED
  get popUpNotificationClass() {
    let value = 'dean-popup-notification';
    if (this.standard) value += ` dean-popup-notification-standard`;
    else if (this.success) value += ` dean-popup-notification-success`;
    else if (this.info) value += ` dean-popup-notification-info`;
    else if (this.warning) value += ` dean-popup-notification-warning`;
    else if (this.danger) value += ` dean-popup-notification-danger`;
    else if (this.theme) {
      value += `  dean-popup-notification-${this.theme}`;
    } else value += `  dean-popup-notification-standard`;
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
/* Import */
@import '../scss/vars';

.dean-popup-notification {
  @include display-flex();
  align-items: center;
  justify-content: flex-start;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  font-weight: 500;
  z-index: 971;
  padding: 10px;
  opacity: 0.75;
  font-size: 14px;

  .dean-popup-notification-text {
    @include display-flex();
    align-items: center;
    justify-content: center;
    p {
      text-align: center;
      overflow-wrap: break-word;
      @include hyphens(auto);
      padding: 0 10px 0 10px;
    }
  }

  .info-icon,
  .close-icon {
    display: flex;
    height: 20px;
    cursor: pointer;
  }
  .info-icon {
    justify-content: flex-start;
    align-self: flex-start;
  }
  .close-icon {
    justify-content: flex-end;
    align-self: flex-start;
  }
}

.dean-popup-notification-standard {
  background: var(--color-light-shade-2, $color-light-shade-2);
  color: black;
  fill: black;
  /*
    color: var(--color-dark-shade-2, $color-dark-shade-2);
    fill: var(--color-dark-shade-2, $color-dark-shade-2);
    background: var(--color-light-shade-2, $color-light-shade-2);
    border: 1px solid var(--color-light, $color-light);
    */
}

.dean-popup-notification-success {
  background: var(--color-info-success, $color-info-success);
  color: white;
  fill: white;
  /*
    color: var(--color-info-success, $color-info-success);
    fill: var(--color-info-success, $color-info-success);
    background: var(--color-info-success-bg, $color-info-success-bg);
    border: 1px solid var(--color-info-success-border, $color-info-success-border);
    */
}

.dean-popup-notification-info {
  background: var(--color-info-standard, $color-info-standard);
  color: white;
  fill: white;
  /*
    color: var(--color-info-standard, $color-info-standard);
    fill: var(--color-info-standard, $color-info-standard);
    background: var(--color-info-standard-bg, $color-info-standard-bg);
    border: 1px solid var(--color-info-standard-border, $color-info-standard-border);
    */
}

.dean-popup-notification-warning {
  background: var(--color-info-warning, $color-info-warning);
  color: white;
  fill: white;
  /*
    color: var(--color-info-warning, $color-info-warning);
    fill: var(--color-info-warning, $color-info-warning);
    background: var(--color-info-warning-bg, $color-info-warning-bg);
    border: 1px solid var(--color-info-warning-border, $color-info-warning-border);
    */
}

.dean-popup-notification-danger {
  background: var(--color-info-danger, $color-info-danger);
  color: white;
  fill: white;
  /*
    color: var(--color-info-danger, $color-info-danger);
    fill: var(--color-info-danger, $color-info-danger);
    background: var(--color-info-danger-bg, $color-info-danger-bg);
    border: 1px solid var(--color-info-danger-border, $color-info-danger-border);
    */
}
</style>
